import { Link, createFileRoute } from '@tanstack/react-router'
import { DatasetsPage, parseDatasetListSearch } from '@/features/model-training'

export const Route = createFileRoute('/app/model-training/datasets')({
  validateSearch: parseDatasetListSearch,
  component: DatasetsRoute,
})

function DatasetsRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <DatasetsPage
      search={search}
      onSearchChange={(patch) => {
        void navigate({ search: (previous) => ({ ...previous, ...patch }), replace: true })
      }}
      renderPreviewLink={(dataset, content, className) => (
        <Link
          to="/app/model-training/datasets/$datasetId/preview"
          params={{ datasetId: dataset.id }}
          // Previous on the Data Preview returns to this search, sort, page and view.
          state={{ datasetList: search }}
          className={className}
        >
          {content}
        </Link>
      )}
    />
  )
}
